import { AcquiredClientProductMetric } from 'models/acquired'

import { formatNumberStringToPrice, formatNumberWithSpaces } from 'shared/libs'

import styles from './ProductMetricsCell.module.scss'

interface Props {
  productMetrics?: AcquiredClientProductMetric[]
  valueKey: 'amount' | 'transaction_count'
}

export const ProductMetricsCell = ({ productMetrics, valueKey }: Props) => {
  if (!productMetrics?.length) return <>-</>

  return (
    <div className={styles.container}>
      {productMetrics.map(metric => (
        <div className={styles.row} key={metric.code}>
          <span className={styles.name}>{metric.name}</span>
          <span className={styles.divider} />
          <span className={styles.value}>
            {valueKey === 'amount' &&
              formatNumberStringToPrice(metric[valueKey])}
            {valueKey === 'transaction_count' &&
              formatNumberWithSpaces(metric[valueKey])}
          </span>
        </div>
      ))}
    </div>
  )
}
